import { format, formatDistanceToNowStrict, isToday, isYesterday, isThisYear } from "date-fns";

export function parseDate(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function fmtRel(iso) {
  const d = parseDate(iso);
  if (!d) return "";
  try {
    return formatDistanceToNowStrict(d, { addSuffix: true });
  } catch {
    return "";
  }
}

export function fmtTime(iso) {
  const d = parseDate(iso);
  return d ? format(d, "HH:mm") : "";
}

export function fmtDateTime(iso) {
  const d = parseDate(iso);
  if (!d) return "—";
  if (isToday(d)) return `Today ${format(d, "HH:mm")}`;
  if (isYesterday(d)) return `Yesterday ${format(d, "HH:mm")}`;
  return format(d, isThisYear(d) ? "d MMM, HH:mm" : "d MMM yyyy, HH:mm");
}

export function fmtDate(iso) {
  const d = parseDate(iso);
  if (!d) return "—";
  return format(d, isThisYear(d) ? "d MMM" : "d MMM yyyy");
}

export function fmtDayLabel(iso) {
  const d = parseDate(iso);
  if (!d) return "";
  if (isToday(d)) return "Today";
  if (isYesterday(d)) return "Yesterday";
  return format(d, "EEEE, d MMM");
}

export function fmtNumber(n) {
  if (n == null || Number.isNaN(Number(n))) return "0";
  return new Intl.NumberFormat("en-IN").format(Number(n));
}

export function fmtCompact(n) {
  if (n == null) return "0";
  return new Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 1 }).format(Number(n));
}

export function fmtCurrency(n, currency = "INR") {
  try {
    return new Intl.NumberFormat(currency === "INR" ? "en-IN" : "en", { style: "currency", currency, maximumFractionDigits: 0 }).format(Number(n || 0));
  } catch {
    return `${currency} ${fmtNumber(n)}`;
  }
}

export function fmtPhone(num) {
  if (!num) return "";
  const s = String(num);
  if (s.length === 12 && s.startsWith("91")) return `+91 ${s.slice(2, 7)} ${s.slice(7)}`;
  if (s.length === 11 && s.startsWith("1")) return `+1 ${s.slice(1, 4)} ${s.slice(4, 7)} ${s.slice(7)}`;
  return `+${s}`;
}

export function fmtDuration(seconds) {
  if (seconds == null) return "—";
  const s = Math.max(0, Math.round(seconds));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m ${s % 60}s`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
  return `${Math.floor(s / 86400)}d ${Math.floor((s % 86400) / 3600)}h`;
}

export function initials(name) {
  const parts = String(name || "?").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts[0].startsWith("DEMO:")) parts.shift();
  return parts.slice(0, 2).map((p) => p[0]).join("").toUpperCase() || "?";
}

export function pct(part, total) {
  if (!total) return 0;
  return Math.round((part / total) * 1000) / 10;
}

export function toLocalInputValue(iso) {
  const d = parseDate(iso);
  if (!d) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalInputValue(v) {
  if (!v) return null;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

export function avatarHue(key) {
  let h = 0;
  for (const ch of String(key || "")) h = (h * 31 + ch.charCodeAt(0)) % 360;
  return h;
}
